import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { SectionHeading } from "./ui";

const FAQS = [
  { q: "Can I search homes through Wallstreet Realty?", a: "Yes. Use the Search Homes option to browse available properties through the Wallstreet Realty home search." },
  { q: "Is the home search powered by IDX?", a: "Yes. The website includes an iHomeFinder IDX section so buyers can search available homes." },
  { q: "Can I speak with a buyer agent?", a: "Yes. Buyers can book a consultation or request help from a Wallstreet Realty buyer agent." },
  { q: "Can licensed agents join Wallstreet Realty?", a: "Yes. Licensed real estate agents can apply to join Wallstreet Realty and learn about the brokerage model, support, tools, and growth opportunities." },
  { q: "Does Wallstreet Realty help sellers?", a: "Yes. Sellers can request a home value and speak with a listing professional about pricing, preparation, and strategy." },
  { q: "What areas does Wallstreet Realty serve?", a: "Wallstreet Realty serves Southern California, including Los Angeles County, Orange County, and surrounding communities." },
];

export const FaqSection = () => {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow="Questions" title="Frequently Asked Questions" center />
        <div className="mt-10 space-y-3">
          {FAQS.map((f, i) => (
            <div
              key={i}
              className="border border-[#E5E5E5] rounded-[16px] overflow-hidden bg-white"
            >
              <button
                data-testid={`faq-toggle-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
              >
                <span className="font-heading font-bold text-[#2D2D37] text-[16px]">{f.q}</span>
                <span className="shrink-0 text-[#254369]">
                  {open === i ? <Minus size={20} /> : <Plus size={20} />}
                </span>
              </button>
              {open === i && (
                <div data-testid={`faq-answer-${i}`} className="px-6 pb-5 -mt-1 text-[15px] leading-relaxed text-[#2D2D37]/70">
                  {f.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
